<div class="app-shell" [class.is-collapsed]="theme.sidebarCollapsed()" [class.is-mobile-open]="theme.mobileSidebarOpen()">
  <app-default-sidebar class="app-shell__sidebar" />

  @if (theme.mobileSidebarOpen()) {
    <div class="app-shell__backdrop" (click)="theme.mobileSidebarOpen.set(false)" aria-hidden="true"></div>
  }

  <div class="app-shell__main">
    <app-default-header />
    <main class="app-shell__content" id="main-content">
      <router-outlet />
    </main>
    <app-default-footer />
  </div>
</div>
